<!--
 * @Description: 网络课程学习任务 列表
 * @Author: PF
 * @Date: 2025-10-30 09:41:00
 * @LastEditors: PF
 * @LastEditTime: 2025-12-24 11:57:43
-->
<template>
  <div>
    <el-dialog class="wp90 hp90" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <List />
          </el-icon>
          <span class="header-title">网络课程学习任务</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList = false; homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
              <el-form-item>
                <el-select placeholder="学期" v-model="dataGrid.parms.xqid" clearable filterable @change='bindTable()'>
                  <el-option v-for="(item) in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="网络课程名称" v-model="dataGrid.parms.wlkcmc" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="bindTable()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <el-table-column label="序号" type="index" width="55" fixed align="center" />
              <el-table-column label="学期" prop="xqmc" width="155px" align="center" />
              <el-table-column label="课程计划" prop="kcmc" show-overflow-tooltip align="center" />
              <el-table-column label="网络课程" prop="wlkcmc" show-overflow-tooltip align="center" />
              <el-table-column label="测试试卷" show-overflow-tooltip align="center" :formatter="ceShiFormatter" />
              <el-table-column label="考试试卷" show-overflow-tooltip align="center" :formatter="kaoShiFormatter" />
              <el-table-column label="操作" width="220" fixed="right" align="center">
                <template #default="scope">
                  <!-- xfzt 发布状态 0未发布,1已发布 -->
                  <el-button link type="primary" v-if="!scope.row.xfzt" @click="openFaBu=true;ruleForm.id=scope.row.id">发布</el-button>
                  <el-button link type="success" @click="openDetail=true;row=scope.row">详情</el-button>
                  <el-button link type="primary" v-if="scope.row.xfzt" @click="openEdit=true;row=scope.row">试卷管理</el-button>
                  <el-button link type="primary" v-if="!scope.row.xfzt" @click="openEdit=true;row=scope.row">添加网络课程</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
  <el-dialog v-model="openFaBu" title="发布" class="w400 h300" :before-close="handleClose">
    <el-form ref="ruleFormRef" :model="ruleForm" label-position="top">
      <el-row>
        <el-col :span="24">
          <el-form-item label="网络课程截至日期" prop="jzsj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
            <el-date-picker v-model="ruleForm.jzsj" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <div></div>
        <div class="footer_but">
          <el-button type="primary" @click="toFaBu()">发布</el-button>
          <el-button type="info" @click="handleClose()">关闭</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { homeCloseWindow, loadList, loadSelect, submitDataGridAction, actionPost } from '@/api/common.js'
import { ElMessageBox } from 'element-plus'
import { successLePrompt, warningLePrompt } from '@/utils/promptInfo'
import pagination from '@/components/pagination.vue'
import edit from './edit.vue'
import detail from './detail.vue'

const props = defineProps({ open: { type: String, required: true } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 弹窗
const row = ref()
const openList = ref(false)
const openEdit = ref(false)
const openDetail = ref(false)
const openFaBu = ref(false)

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'CreatedTime', order: 'descending' },
  multipleSelection: [],
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.jzgid = JSON.parse(sessionStorage.getItem('USER_INFO')).id
  loadList({
    url: '/api/v2/wangluojiaoxue/renwu/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
    }
  })
}
// 获取试卷
const ceShiFormatter = (row) => {
  // 试卷类型:1-考试 2-测试
  let list = row.shijuanVOList.filter(item => item.sjlx === 2);
  return list ? list.map(item => item.sjmc).join(',') : ''
}
// 获取试卷
const kaoShiFormatter = (row) => {
  // 试卷类型:1-考试 2-测试
  let list = row.shijuanVOList.filter(item => item.sjlx === 1);
  return list ? list.map(item => item.sjmc).join(',') : ''
}

const xqData = ref() // 学期
watch(
  () => props.open,
  () => {
    if (props.open === 'wangluokechengxuexirenwu') {
      openList.value = true
      loadSelect({
        url: '/api/v2/pdp/xueqi/list',
        data: xqData,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          let info = res.data.find(item => item.sfdqxq === true)
          dataGrid.value.parms.xqid = info ? info.id : ''
          bindTable()
        }
      })
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)

const ruleFormRef = ref(null)
const ruleForm = ref({})

const toFaBu = () => {
  ElMessageBox.confirm('确认要发布吗?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    const options = { url: '/api/v2/wangluojiaoxue/renwu/fabu', data: ruleForm.value }
    actionPost(options).then((res) => {
      dataGrid.value.loading = false
      if (res.code === 200) {
        bindTable()
        handleClose()
        successLePrompt(res.message)
      } else {
        warningLePrompt(res.message)
      }
    })
  })
}

const handleClose = () => {
  ruleForm.value = {}
  openFaBu.value = false
}

// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/wangluojiaoxue/renwu',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function (res) {
      bindTable()
    }
  })
}

</script>
